var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0184 10.6787L13.3234 7.98367L15.2714 6.03467L17.9654 8.72867L16.0184 10.6787ZM9.07941 17.6247L6.10241 17.8957L6.36641 14.9397L11.9834 9.32267L14.6794 12.0187L9.07941 17.6247ZM19.4034 7.33767L19.4024 7.33667L16.6644 4.59867C15.9234 3.85967 14.6504 3.82467 13.9484 4.52967L4.95241 13.5257C4.62641 13.8507 4.42441 14.2827 4.38241 14.7397L4.00341 18.9097C3.97741 19.2047 4.08241 19.4967 4.29241 19.7067C4.48141 19.8957 4.73641 19.9997 4.99941 19.9997C5.03041 19.9997 5.06041 19.9987 5.09041 19.9957L9.26041 19.6167C9.71841 19.5747 10.1494 19.3737 10.4744 19.0487L19.4714 10.0517C20.1994 9.32167 20.1684 8.10367 19.4034 7.33767Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/EditPencil.599c25cc79df31225c1de0439876d6bb.svg";
export { ForwardRef as ReactComponent };